<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer" :class="{'layer--nobutton': tastingStep != 6}">
      <div class="layer__header">
        <!-- 시음 토출 대기 팝업 문구 -->
        <div v-if="tastingStep == 2 || tastingStep == 1">
          <div class="lyr-title">{{ $t('User.WineFinish.msg12') }}({{ itemNum + 1 }}/{{ totalCnt }})</div>
          <div class="ft-point">{{ $t('User.WineFinish.msg13') }}</div>
        </div>

        <!-- 시음 토출 버튼 팝업 문구 -->
        <div v-else-if="tastingStep == 3">
          <div class="lyr-title">{{ $t('User.WineFinish.msg14') }}({{ itemNum + 1 }}/{{ totalCnt }})</div>
          <div class="ft-point">{{ $t('User.WineFinish.msg15') }}</div>
        </div>

        <!-- 시음 토출 완료 팝업 문구 -->
        <div v-else-if="tastingStep == 6">
          <div class="lyr-title">{{ $t('User.WineFinish.msg16') }}({{ itemNum + 1 }}/{{ totalCnt }})</div>
          <div class="ft-point">{{ $t('User.WineFinish.msg11') }}</div>
        </div>

        <div v-if="tastingStep != 6">
          <div class="lyr-txt">{{ $t('User.WineFinish.msg3') }}</div>
          <div class="lyr-txt tasting-num ft-point">{{ strToInt(wineColumn) }}{{ $t('User.WineFinish.msg4') }}</div>
        </div>
      </div>
      <div
        class="layer__body"
        @mouseup="
          if (nextNum == 0) nextTimeout();
          nextStep();
        "
      >
        <img v-if="tastingStep == 2" src="@/assets/images/user/artwork_popup_wine_sample_ready_3d.gif" alt="" class="img-size" />
        <img v-else-if="tastingStep == 3" src="@/assets/images/user/artwork_popup_wine_sample_dischage_3d.gif" alt="" class="img-size" />
        <img v-else src="@/assets/images/user/img_sample_fin.png" alt="" class="img-size" />
      </div>
      <div class="layer__button" v-if="tastingStep == 6 && finishYn && itemNum + 1 == totalCnt">
        <button class="btn btn--color btn--xlg btn-anim" @mouseup="setComplete">{{ $t('User.WineFinish.msg99') }}</button>
      </div>
      <div class="layer__button" v-if="failYn">
        <button class="btn btn--color btn--xlg btn-anim" @mouseup="dischargeCall">{{ $t('User.WineFinish.msg98') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tastingDischarge',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      orgBaskets: this.$store.getters.getOrgBaskets,
      tastingStep: 2,
      itemNum: 0,
      failYn: false,
      nextNum: 0,
      finishYn: false,
    };
  },
  mounted() {
    this.finishYn = true;
  },
  props: {
    wineTran: String,
  },
  methods: {
    nextStep() {
      this.nextNum++;
      if (this.nextNum >= 10) {
        if (this.itemNum + 1 < this.totalCnt) {
          this.itemNum++;
          this.tastingStep = 2;
          this.nextNum = 0;
          this.dischargeCall();
        } else {
          this.tastingStep = 6;
          this.finishYn = true;
        }
      }
    },
    nextTimeout() {
      setTimeout(() => {
        if (this.nextNum < 10) {
          this.nextNum = 0;
        }
      }, 5000);
    },
    setComplete() {
      let url = '/api/vending/completeDischarge ';

      axios
        .post(url, null)
        .then((response) => {
          if (response.data.status != 0) {
            this.$logInfo(`completeDischarge Fail status : ${response.data.status} message : ${response.data.message}`);
          }
        })
        .catch((error) => {
          this.$logInfo(`completeDischarge axios Error : ${error}`);
        });

      this.$router.replace({name: 'bell-select', params: {tran: this.wineTran}});
    },
    dischargeCall() {
      let url = '/api/vending/discharge';
      let param = {
        //보틀 판매인지 시음인지에 따라 아래 텍스트 변경해서 전달요망
        dischargeType: 'TastingMachine', // 보틀판매: 'VendingMachine', 시음판매: 'TastingMachine'
        //TODO 시음 또는 보틀 슬롯 번호 전달해줘야함, 현재는 고정값
        dischargeColumn: this.wineColumn, // 토출할 컬럼 번호
        // 시음+판매기(시음 컬럼: 1 ~ 16, 판매 컬럼: 1 ~ 16)
        // 판매기(판매 컬럼: 1 ~ 24)
      };

      axios
        .post(url, param)
        .then((response) => {
          if (response.data.status != 0) {
            this.$logInfo(`discharge call Fail status : ${response.data.status} message : ${response.data.message}`);
          }
        })
        .catch((error) => {
          this.$logInfo(`discharge call axios Error : ${error}`);
        });
    },
    strToInt(val) {
      var regex = /[^0-9]/g;
      var result = Number(val.replace(regex, ''));
      return result;
    },
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    erpArray: function () {
      let arr = [];
      this.orgBaskets.forEach((basket) => {
        for (let i = 0; i < basket.SALES_QTY; i++) {
          arr.push(basket.ERP_ITEM_CD);
        }
      });
      return arr;
    },
    wineColumn: function () {
      return this.erpArray[this.itemNum];
    },
    totalCnt: function () {
      let sum = 0;
      this.orgBaskets.forEach((basket) => {
        sum += basket.SALES_QTY;
      });
      return sum;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped>
.tasting-num {
  font-size: 3em;
}
</style>
